/**
 * Country data with phone codes and flag emojis
 */

export interface CountryData {
  name: string;
  code: string;       // ISO 3166-1 alpha-2
  dialCode: string;   // e.g. "+1"
  flag: string;       // emoji flag
}

/**
 * Get flag image URL from flagcdn.com CDN.
 * Returns a 20px wide PNG flag for the given ISO country code.
 */
export function getFlagImageUrl(countryCode: string): string {
  return `https://flagcdn.com/w40/${countryCode.toLowerCase()}.png`;
}

export const COUNTRIES: CountryData[] = [
  { name: 'Afghanistan', code: 'AF', dialCode: '+93', flag: '🇦🇫' },
  { name: 'Albania', code: 'AL', dialCode: '+355', flag: '🇦🇱' },
  { name: 'Algeria', code: 'DZ', dialCode: '+213', flag: '🇩🇿' },
  { name: 'Argentina', code: 'AR', dialCode: '+54', flag: '🇦🇷' },
  { name: 'Australia', code: 'AU', dialCode: '+61', flag: '🇦🇺' },
  { name: 'Austria', code: 'AT', dialCode: '+43', flag: '🇦🇹' },
  { name: 'Bangladesh', code: 'BD', dialCode: '+880', flag: '🇧🇩' },
  { name: 'Belgium', code: 'BE', dialCode: '+32', flag: '🇧🇪' },
  { name: 'Bolivia', code: 'BO', dialCode: '+591', flag: '🇧🇴' },
  { name: 'Brazil', code: 'BR', dialCode: '+55', flag: '🇧🇷' },
  { name: 'Canada', code: 'CA', dialCode: '+1', flag: '🇨🇦' },
  { name: 'Chile', code: 'CL', dialCode: '+56', flag: '🇨🇱' },
  { name: 'China', code: 'CN', dialCode: '+86', flag: '🇨🇳' },
  { name: 'Colombia', code: 'CO', dialCode: '+57', flag: '🇨🇴' },
  { name: 'Costa Rica', code: 'CR', dialCode: '+506', flag: '🇨🇷' },
  { name: 'Croatia', code: 'HR', dialCode: '+385', flag: '🇭🇷' },
  { name: 'Cuba', code: 'CU', dialCode: '+53', flag: '🇨🇺' },
  { name: 'Czech Republic', code: 'CZ', dialCode: '+420', flag: '🇨🇿' },
  { name: 'Denmark', code: 'DK', dialCode: '+45', flag: '🇩🇰' },
  { name: 'Dominican Republic', code: 'DO', dialCode: '+1', flag: '🇩🇴' },
  { name: 'Ecuador', code: 'EC', dialCode: '+593', flag: '🇪🇨' },
  { name: 'Egypt', code: 'EG', dialCode: '+20', flag: '🇪🇬' },
  { name: 'El Salvador', code: 'SV', dialCode: '+503', flag: '🇸🇻' },
  { name: 'Finland', code: 'FI', dialCode: '+358', flag: '🇫🇮' },
  { name: 'France', code: 'FR', dialCode: '+33', flag: '🇫🇷' },
  { name: 'Germany', code: 'DE', dialCode: '+49', flag: '🇩🇪' },
  { name: 'Greece', code: 'GR', dialCode: '+30', flag: '🇬🇷' },
  { name: 'Guatemala', code: 'GT', dialCode: '+502', flag: '🇬🇹' },
  { name: 'Honduras', code: 'HN', dialCode: '+504', flag: '🇭🇳' },
  { name: 'Hong Kong', code: 'HK', dialCode: '+852', flag: '🇭🇰' },
  { name: 'Hungary', code: 'HU', dialCode: '+36', flag: '🇭🇺' },
  { name: 'Iceland', code: 'IS', dialCode: '+354', flag: '🇮🇸' },
  { name: 'India', code: 'IN', dialCode: '+91', flag: '🇮🇳' },
  { name: 'Indonesia', code: 'ID', dialCode: '+62', flag: '🇮🇩' },
  { name: 'Iran', code: 'IR', dialCode: '+98', flag: '🇮🇷' },
  { name: 'Iraq', code: 'IQ', dialCode: '+964', flag: '🇮🇶' },
  { name: 'Ireland', code: 'IE', dialCode: '+353', flag: '🇮🇪' },
  { name: 'Israel', code: 'IL', dialCode: '+972', flag: '🇮🇱' },
  { name: 'Italy', code: 'IT', dialCode: '+39', flag: '🇮🇹' },
  { name: 'Jamaica', code: 'JM', dialCode: '+1', flag: '🇯🇲' },
  { name: 'Japan', code: 'JP', dialCode: '+81', flag: '🇯🇵' },
  { name: 'Jordan', code: 'JO', dialCode: '+962', flag: '🇯🇴' },
  { name: 'Kenya', code: 'KE', dialCode: '+254', flag: '🇰🇪' },
  { name: 'Kuwait', code: 'KW', dialCode: '+965', flag: '🇰🇼' },
  { name: 'Malaysia', code: 'MY', dialCode: '+60', flag: '🇲🇾' },
  { name: 'Mexico', code: 'MX', dialCode: '+52', flag: '🇲🇽' },
  { name: 'Morocco', code: 'MA', dialCode: '+212', flag: '🇲🇦' },
  { name: 'Netherlands', code: 'NL', dialCode: '+31', flag: '🇳🇱' },
  { name: 'New Zealand', code: 'NZ', dialCode: '+64', flag: '🇳🇿' },
  { name: 'Nicaragua', code: 'NI', dialCode: '+505', flag: '🇳🇮' },
  { name: 'Nigeria', code: 'NG', dialCode: '+234', flag: '🇳🇬' },
  { name: 'Norway', code: 'NO', dialCode: '+47', flag: '🇳🇴' },
  { name: 'Pakistan', code: 'PK', dialCode: '+92', flag: '🇵🇰' },
  { name: 'Panama', code: 'PA', dialCode: '+507', flag: '🇵🇦' },
  { name: 'Paraguay', code: 'PY', dialCode: '+595', flag: '🇵🇾' },
  { name: 'Peru', code: 'PE', dialCode: '+51', flag: '🇵🇪' },
  { name: 'Philippines', code: 'PH', dialCode: '+63', flag: '🇵🇭' },
  { name: 'Poland', code: 'PL', dialCode: '+48', flag: '🇵🇱' },
  { name: 'Portugal', code: 'PT', dialCode: '+351', flag: '🇵🇹' },
  { name: 'Puerto Rico', code: 'PR', dialCode: '+1', flag: '🇵🇷' },
  { name: 'Qatar', code: 'QA', dialCode: '+974', flag: '🇶🇦' },
  { name: 'Romania', code: 'RO', dialCode: '+40', flag: '🇷🇴' },
  { name: 'Russia', code: 'RU', dialCode: '+7', flag: '🇷🇺' },
  { name: 'Saudi Arabia', code: 'SA', dialCode: '+966', flag: '🇸🇦' },
  { name: 'Singapore', code: 'SG', dialCode: '+65', flag: '🇸🇬' },
  { name: 'South Africa', code: 'ZA', dialCode: '+27', flag: '🇿🇦' },
  { name: 'South Korea', code: 'KR', dialCode: '+82', flag: '🇰🇷' },
  { name: 'Spain', code: 'ES', dialCode: '+34', flag: '🇪🇸' },
  { name: 'Sweden', code: 'SE', dialCode: '+46', flag: '🇸🇪' },
  { name: 'Switzerland', code: 'CH', dialCode: '+41', flag: '🇨🇭' },
  { name: 'Taiwan', code: 'TW', dialCode: '+886', flag: '🇹🇼' },
  { name: 'Thailand', code: 'TH', dialCode: '+66', flag: '🇹🇭' },
  { name: 'Turkey', code: 'TR', dialCode: '+90', flag: '🇹🇷' },
  { name: 'Ukraine', code: 'UA', dialCode: '+380', flag: '🇺🇦' },
  { name: 'United Arab Emirates', code: 'AE', dialCode: '+971', flag: '🇦🇪' },
  { name: 'United Kingdom', code: 'GB', dialCode: '+44', flag: '🇬🇧' },
  { name: 'United States', code: 'US', dialCode: '+1', flag: '🇺🇸' },
  { name: 'Uruguay', code: 'UY', dialCode: '+598', flag: '🇺🇾' },
  { name: 'Venezuela', code: 'VE', dialCode: '+58', flag: '🇻🇪' },
  { name: 'Vietnam', code: 'VN', dialCode: '+84', flag: '🇻🇳' },
];

export const LANGUAGES: string[] = [
  'Arabic',
  'Bengali',
  'Chinese (Mandarin)',
  'Chinese (Cantonese)',
  'Czech',
  'Danish',
  'Dutch',
  'English',
  'Finnish',
  'French',
  'German',
  'Greek',
  'Hebrew',
  'Hindi',
  'Hungarian',
  'Indonesian',
  'Italian',
  'Japanese',
  'Korean',
  'Malay',
  'Norwegian',
  'Persian',
  'Polish',
  'Portuguese',
  'Romanian',
  'Russian',
  'Spanish',
  'Swedish',
  'Thai',
  'Turkish',
  'Ukrainian',
  'Urdu',
  'Vietnamese',
];

/**
 * Get the country code for a phone number based on its dial code prefix.
 * Returns the matching ISO country code (e.g. 'US') or empty string.
 * For shared dial codes like +1, prefers US.
 */
export function getCountryCodeForPhone(phone: string): string {
  if (!phone) return '';
  const cleaned = phone.replace(/[\s\-()]/g, '');
  if (!cleaned.startsWith('+')) return '';

  const PREFERRED: Record<string, string> = { '+1': 'US', '+7': 'RU' };

  // Try longer dial codes first (e.g., +880 before +8)
  const sorted = [...COUNTRIES].sort((a, b) => b.dialCode.length - a.dialCode.length);
  let firstMatch = '';
  for (const country of sorted) {
    if (cleaned.startsWith(country.dialCode)) {
      if (PREFERRED[country.dialCode] === country.code) return country.code;
      if (!firstMatch) firstMatch = country.code;
    }
  }
  return firstMatch;
}

/**
 * @deprecated Use getCountryCodeForPhone + getFlagImageUrl instead
 */
export function getFlagForPhone(phone: string): string {
  return getCountryCodeForPhone(phone);
}

/**
 * Get US state/province/city suggestions for a given country.
 * Returns common locations. 
 */
export function getLocationsForCountry(country: string): string[] {
  const locationMap: Record<string, string[]> = {
    'United States': [
      'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado',
      'Connecticut', 'Delaware', 'District of Columbia', 'Florida', 'Georgia', 'Hawaii', 'Idaho',
      'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana',
      'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota',
      'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada',
      'New Hampshire', 'New Jersey', 'New Mexico', 'New York',
      'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon',
      'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota',
      'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington',
      'West Virginia', 'Wisconsin', 'Wyoming',
    ],
    'Canada': [
      'Alberta', 'British Columbia', 'Manitoba', 'New Brunswick',
      'Newfoundland and Labrador', 'Northwest Territories', 'Nova Scotia', 'Nunavut', 'Ontario',
      'Prince Edward Island', 'Quebec', 'Saskatchewan', 'Yukon',
    ],
    'Mexico': [
      'Aguascalientes', 'Baja California', 'Baja California Sur', 'Campeche',
      'Chiapas', 'Chihuahua', 'Ciudad de México', 'Coahuila', 'Colima',
      'Durango', 'Estado de México', 'Guanajuato', 'Guerrero', 'Hidalgo',
      'Jalisco', 'Michoacán', 'Morelos', 'Nayarit', 'Nuevo León',
      'Oaxaca', 'Puebla', 'Querétaro', 'Quintana Roo', 'San Luis Potosí',
      'Sinaloa', 'Sonora', 'Tabasco', 'Tamaulipas', 'Tlaxcala',
      'Veracruz', 'Yucatán', 'Zacatecas',
    ],
    'China': [
      'Beijing', 'Shanghai', 'Guangdong', 'Shenzhen', 'Zhejiang',
      'Jiangsu', 'Shandong', 'Fujian', 'Sichuan', 'Hubei',
    ],
    'Germany': [
      'Baden-Württemberg', 'Bavaria', 'Berlin', 'Brandenburg', 'Bremen',
      'Hamburg', 'Hesse', 'Lower Saxony', 'North Rhine-Westphalia',
      'Rhineland-Palatinate', 'Saxony', 'Thuringia',
    ],
    'United Kingdom': [
      'England', 'Scotland', 'Wales', 'Northern Ireland',
      'London', 'Manchester', 'Birmingham', 'Leeds', 'Liverpool',
    ],
    'France': [
      'Île-de-France', 'Provence-Alpes-Côte d\'Azur', 'Auvergne-Rhône-Alpes',
      'Occitanie', 'Nouvelle-Aquitaine', 'Hauts-de-France', 'Grand Est',
    ],
    'Spain': [
      'Andalusia', 'Catalonia', 'Madrid', 'Valencia', 'Basque Country',
      'Galicia', 'Castile and León', 'Canary Islands',
    ],
    'Italy': [
      'Lombardy', 'Lazio', 'Campania', 'Sicily', 'Veneto',
      'Piedmont', 'Emilia-Romagna', 'Tuscany',
    ],
    'Japan': [
      'Tokyo', 'Osaka', 'Kyoto', 'Hokkaido', 'Aichi', 'Fukuoka',
      'Kanagawa', 'Saitama', 'Chiba', 'Hyogo',
    ],
    'South Korea': [
      'Seoul', 'Busan', 'Incheon', 'Daegu', 'Daejeon', 'Gyeonggi',
    ],
    'India': [
      'Maharashtra', 'Karnataka', 'Tamil Nadu', 'Delhi', 'Gujarat',
      'Rajasthan', 'West Bengal', 'Telangana', 'Kerala',
    ],
    'Brazil': [
      'São Paulo', 'Rio de Janeiro', 'Minas Gerais', 'Bahia',
      'Paraná', 'Santa Catarina', 'Rio Grande do Sul',
    ],
    'Colombia': [
      'Amazonas', 'Antioquia', 'Arauca', 'Atlántico', 'Bogotá D.C.',
      'Bolívar', 'Boyacá', 'Caldas', 'Caquetá', 'Casanare',
      'Cauca', 'Cesar', 'Chocó', 'Córdoba', 'Cundinamarca',
      'Guainía', 'Guaviare', 'Huila', 'La Guajira', 'Magdalena',
      'Meta', 'Nariño', 'Norte de Santander', 'Putumayo', 'Quindío',
      'Risaralda', 'San Andrés y Providencia', 'Santander', 'Sucre',
      'Tolima', 'Valle del Cauca', 'Vaupés', 'Vichada',
    ],
    'Australia': [
      'Australian Capital Territory', 'New South Wales', 'Northern Territory', 'Queensland',
      'South Australia', 'Tasmania', 'Victoria', 'Western Australia',
    ],
    'Argentina': [
      'Buenos Aires', 'Catamarca', 'Chaco', 'Chubut', 'Córdoba',
      'Corrientes', 'Entre Ríos', 'Formosa', 'Jujuy', 'La Pampa',
      'La Rioja', 'Mendoza', 'Misiones', 'Neuquén', 'Río Negro',
      'Salta', 'San Juan', 'San Luis', 'Santa Cruz', 'Santa Fe',
      'Santiago del Estero', 'Tierra del Fuego', 'Tucumán',
    ],
    'Chile': [
      'Arica y Parinacota', 'Tarapacá', 'Antofagasta', 'Atacama',
      'Coquimbo', 'Valparaíso', 'Metropolitana de Santiago', "O'Higgins",
      'Maule', 'Ñuble', 'Biobío', 'La Araucanía', 'Los Ríos',
      'Los Lagos', 'Aysén', 'Magallanes',
    ],
    'Peru': [
      'Amazonas', 'Áncash', 'Apurímac', 'Arequipa', 'Ayacucho',
      'Cajamarca', 'Callao', 'Cusco', 'Huancavelica', 'Huánuco',
      'Ica', 'Junín', 'La Libertad', 'Lambayeque', 'Lima',
      'Loreto', 'Madre de Dios', 'Moquegua', 'Pasco', 'Piura',
      'Puno', 'San Martín', 'Tacna', 'Tumbes', 'Ucayali',
    ],
    'Ecuador': [
      'Azuay', 'Bolívar', 'Cañar', 'Carchi', 'Chimborazo',
      'Cotopaxi', 'El Oro', 'Esmeraldas', 'Galápagos', 'Guayas',
      'Imbabura', 'Loja', 'Los Ríos', 'Manabí', 'Morona Santiago',
      'Napo', 'Orellana', 'Pastaza', 'Pichincha', 'Santa Elena',
      'Santo Domingo de los Tsáchilas', 'Sucumbíos', 'Tungurahua', 'Zamora-Chinchipe',
    ],
    'Venezuela': [
      'Amazonas', 'Anzoátegui', 'Apure', 'Aragua', 'Barinas',
      'Bolívar', 'Carabobo', 'Cojedes', 'Delta Amacuro', 'Distrito Capital',
      'Falcón', 'Guárico', 'Lara', 'Mérida', 'Miranda',
      'Monagas', 'Nueva Esparta', 'Portuguesa', 'Sucre', 'Táchira',
      'Trujillo', 'Vargas', 'Yaracuy', 'Zulia',
    ],
    'Panama': [
      'Bocas del Toro', 'Chiriquí', 'Coclé', 'Colón', 'Darién',
      'Herrera', 'Los Santos', 'Panamá', 'Panamá Oeste', 'Veraguas',
    ],
    'Costa Rica': [
      'San José', 'Alajuela', 'Cartago', 'Heredia', 'Guanacaste', 'Puntarenas', 'Limón',
    ],
  };
  return locationMap[country] || [];
}
